import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import SideNavBarUser from './SideNavBarUser';
import { Switch } from 'react-router-dom';
import {
  BCC_ADD_USER_ROUTE,
  BCC_USER_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  DISCOVERY_USER_ROUTE,
  JFT_USER_ROUTE,
  MGMENT_USER_ROUTE,
  USER_MANAGEMENT_MODULE_ROUTE,
} from '../../routes/routes';
import ManagementAppUser from './ManagementAppUser/ManagementAppUser';
import DiscoveryAppUser from './DiscoveryAppUser/DiscoveryAppUser';
import JftUser from './JFTUser/JftUser';
import useScopes from '../../hooks/useScopes';
import { useSelector } from 'react-redux';
import bccUser from './bccUser/bccUser';
import addUser from './bccUser/addUser';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import changePassword from './ChangePassword';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

function UserManagementScreen() {
  const classes = useStyles();
  const { access } = useScopes();
  const { pathname } = useLocation();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">
              {pathname === '/user-management/add-user'
                ? 'Add Employee'
                : 'User Management'}
            </Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {pathname === '/user-management/add-user'
              ? 'Add an employee to a role and information'
              : 'Managing User'}
          </Typography>
        </Box>
        {pathname === '/user-management/add-user' ? (
          <Box flex={1} textAlign={'right'}>
            <Link to="/user-management/bcc-user">
              <Button variant="outlined" color="primary">
                Cancel
              </Button>
            </Link>
          </Box>
        ) : null}
      </Box>
      <Divider />
      <Box display="flex" flex={10}>
        {pathname === '/user-management/add-user' ? null : (
          <Box minWidth={300} pt={4}>
            <SideNavBarUser />
          </Box>
        )}

        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={[MGMENT_USER_ROUTE, USER_MANAGEMENT_MODULE_ROUTE]}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['user:management:readWrite'],
                })
                  ? ManagementAppUser
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={DISCOVERY_USER_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['user:discovery:readWrite'],
                })
                  ? DiscoveryAppUser
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute exact path={JFT_USER_ROUTE} component={JftUser} />
            <PrivateRoute
              exact
              path={BCC_USER_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin')
                  ? bccUser
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={CHANGE_PASSWORD_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin')
                  ? changePassword
                  : DoNotHaveAccess
              }
            />

            <PrivateRoute
              exact
              path={BCC_ADD_USER_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin')
                  ? addUser
                  : DoNotHaveAccess
              }
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default UserManagementScreen;
